export const HeadlessAppInstalledNotificationDataHooks = {
  container: 'headless-app-installed-notification-container',
  description: 'headless-app-installed-notification-description',
};
